import { useSessionValue } from "./useRecommendationSession";

function validRatings(saved) {
  if (!saved || typeof saved !== "object" || Array.isArray(saved)) return {};
  return Object.fromEntries(Object.entries(saved).filter(([movieId, rating]) =>
    /^[1-9]\d*$/.test(movieId) && Number.isFinite(rating) && rating >= 0 && rating <= 5
  ));
}

export function useMovieRatings(system, study) {
  // The rating namespace is specific to system, participant and active session.
  // No provider vote average, backend record, or default rating is read here.
  return useSessionValue(`${system.toLowerCase()}-movie-ratings:${study.participantId}:${study.sessionId}`, {}, validRatings);
}
